import React from 'react';

// CodeQuest 吉祥物：小熊猫「阿码」，纯内联 SVG，无外部资源依赖
export default function Mascot ({size = 160, className}) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 200 200"
            className={className}
            role="img"
            aria-label="CodeQuest 吉祥物小熊猫阿码"
        >
            <defs>
                <radialGradient id="cqFur" cx="50%" cy="40%" r="70%">
                    <stop offset="0%" stopColor="#f08a3c" />
                    <stop offset="100%" stopColor="#d1662a" />
                </radialGradient>
            </defs>
            {/* 耳朵 */}
            <circle cx="52" cy="58" r="26" fill="#c2551f" />
            <circle cx="148" cy="58" r="26" fill="#c2551f" />
            <circle cx="52" cy="58" r="13" fill="#ffe4c4" />
            <circle cx="148" cy="58" r="13" fill="#ffe4c4" />
            {/* 头 */}
            <circle cx="100" cy="106" r="66" fill="url(#cqFur)" />
            {/* 脸部白斑 */}
            <path d="M100 66c34 0 52 22 52 44 0 26-24 44-52 44s-52-18-52-44c0-22 18-44 52-44Z" fill="#fff6ec" />
            {/* 眼罩 */}
            <path d="M64 96c8-10 20-10 26 0 4 7 2 14-4 18-9 6-24 2-26-8-1-4 0-7 4-10Z" fill="#c2551f" />
            <path d="M136 96c-8-10-20-10-26 0-4 7-2 14 4 18 9 6 24 2 26-8 1-4 0-7-4-10Z" fill="#c2551f" />
            {/* 眼睛 */}
            <circle cx="78" cy="104" r="8" fill="#241a12" />
            <circle cx="122" cy="104" r="8" fill="#241a12" />
            <circle cx="81" cy="101" r="2.6" fill="#fff" />
            <circle cx="125" cy="101" r="2.6" fill="#fff" />
            {/* 鼻子 + 嘴 */}
            <ellipse cx="100" cy="124" rx="7" ry="5" fill="#3a2a1c" />
            <path d="M100 129c0 6-6 9-11 9m11-9c0 6 6 9 11 9" fill="none" stroke="#3a2a1c" strokeWidth="2.4" strokeLinecap="round" />
            {/* 腮红 */}
            <circle cx="66" cy="122" r="7" fill="#ff9d6e" opacity="0.6" />
            <circle cx="134" cy="122" r="7" fill="#ff9d6e" opacity="0.6" />
        </svg>
    );
}
